import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const HOME_BY_ROLE = {
    admin: '/adminDashboard',
    adminStaff: '/adminDashboard',
    doctor: '/doctor/dashboard',
    HrMedical: '/Nurse/Dashboard',
    HrLead: '/Nurse/Dashboard',
    enrollment: '/enrollment/patients',
    billing: '/billing/codes',
    accounting: '/accounting/monthly',
};

export const homeForRole = (role) => HOME_BY_ROLE[role] || '/login';

const AuthPending = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
);

/**
 * Renders `component` only when the signed-in user's role is in `roles`.
 * Waits while auth is resolving, then: unauthenticated -> /login,
 * authenticated but not allowed -> that user's own dashboard.
 */
const RoleRoute = ({ roles, component: Component, ...rest }) => {
    const { isAuthenticated, loading, user } = useSelector((state) => state.auth);

    return (
        <Route
            {...rest}
            render={(props) => {
                if (loading) return <AuthPending />;
                if (!isAuthenticated || !user?.role) return <Redirect to="/login" />;
                if (!roles.includes(user.role)) return <Redirect to={homeForRole(user.role)} />;
                return <Component {...props} />;
            }}
        />
    );
};

export default RoleRoute;
